export const setSelectedMips = (selectedMip) => {
  return {
    type: 'setSelectedMips',
    selectedMip,
  };
};
